export const DISPATCH_METHOD = {
  IN_STORE: 'in_store',
  DELIVERY: 'delivery'
};

export const DELIVERY_STATUS = {
  CONFIRMED: 'CONFIRMED',
  IN_PROGRESS: 'IN_PROGRESS',
  NEAR_PICKUP: 'NEAR_PICKUP',
  PICKED_UP: 'PICKED_UP',
  NEAR_DROPOFF: 'NEAR_DROPOFF',
  COMPLETED: 'COMPLETED'
};
